var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDarkLeftLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68945 18.9169C5.68945 20.6126 7.66717 21.5389 8.96982 20.4534L17.3457 13.4735C18.3052 12.6739 18.3052 11.2002 17.3457 10.4006L8.96982 3.42065C7.66717 2.33511 5.68945 3.26142 5.68945 4.9571L5.68945 18.9169Z",
    fill: "#00323D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDarkLeftLg);
export default __webpack_public_path__ + "static/media/arrow_dark_left-lg.6629f2dcb7cbe9f7846e15ed00214c1b.svg";
export { ForwardRef as ReactComponent };